import { useState, useEffect, useRef } from 'react';
import useFetch from '../../../hooks/useFetch';
import AccountSelector from '../DataExplorerView/AccountSelector';
import ImplementationSelector from '../DataExplorerView/ImplementationSelector';
import Tabs from '../../../sharedComponents/Tabs';
import FullDashboard from './FullDashboard';
import DataSnackOne from './DataSnackOne';
import DataSnackTwo from './DataSnackTwo';
import DataSnackThree from './DataSnackThree';
import DataSnackFour from './DataSnackFour';
import { LoadingIcon, SelectDropdown, DateInput, IconButtonWrapper } from '@prosolve/common-components-ui'
import { FaTimes } from 'react-icons/fa';

export default () => {
  const fetch = useFetch();

  const [selectedAccount, setSelectedAccount] = useState()
  const [selectedImplementation, setSelectedImplementation] = useState()
  const [selectedTerritory, setSelectedTerritory] = useState('')

  const [dateRangeFrom, setDateRangeFrom] = useState('2026-05-14')
  const [dateRangeTo, setDateRangeTo] = useState()

  const dateRangeFromRef = useRef()
  const dateRangeToRef = useRef()

  const onSetSelectedImplementation = (obj) => {
    setSelectedImplementation(obj)
  }

  useEffect(() => {
    setSelectedImplementation(undefined)
  }, [selectedAccount])

  const selectedAccountId = selectedAccount && selectedAccount.Id ? selectedAccount.Id : '';
  const selectedImplementationId = selectedImplementation && selectedImplementation.Id ? selectedImplementation.Id : '';

  // console.log(selectedAccountId)

  // console.log(selectedImplementationId)

  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState()

  const fetchDataStories = async () => {
    try {
      setIsLoading(true);
      const url = `assessment/analytics/dataStories${
        selectedAccountId ? `?accountId=${selectedAccountId}` : ''}${
        (selectedAccountId && selectedImplementationId) ? `&implementationId=${selectedImplementationId}` : ''}${
        selectedTerritory ? `${(selectedAccountId || selectedImplementationId) ? '&' : '?'}territory=${selectedTerritory}` : ''}${
        dateRangeFrom ? `${(selectedAccountId || selectedImplementationId || selectedTerritory) ? '&' : '?'}implementationStartDate=${dateRangeFrom}` : ''}${
        dateRangeTo ? `${(selectedAccountId || selectedImplementationId || selectedTerritory || dateRangeFrom) ? '&' : '?'}implementationEndDate=${dateRangeTo}` : ''}`;
      const response = await fetch(url, { method: 'GET' })
      const jsonData = await response.json();
      if (jsonData.error) {
        setData(undefined)
      } else {
        setData(jsonData)
      }
      setIsLoading(false);
    } catch (e) {
      console.log(e)
      setData(undefined)
      setIsLoading(false);
    }
  }

  useEffect(() => {
    // if (selectedAccountId && selectedImplementationId) {
      fetchDataStories();
    // }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedAccountId, selectedImplementationId, selectedTerritory, dateRangeFrom, dateRangeTo])

  const tabs = ['Full Dashboard', 'Data Snack 1', 'Data Snack 2', 'Data Snack 3', 'Data Snack 4']
  
  const [selectedTab, setSelectedTab] = useState('Full Dashboard')

  const getFocusedDataStory = () => {
    if (selectedTab === 'Full Dashboard') {
      return <FullDashboard data={data} />
    } else if (selectedTab === 'Data Snack 1') {
      return <DataSnackOne data={data} />
    } else if (selectedTab === 'Data Snack 2') {
      return <DataSnackTwo data={data} />
    } else if (selectedTab === 'Data Snack 3') {
      return <DataSnackThree data={data} />
    } else if (selectedTab === 'Data Snack 4') {
      return <DataSnackFour data={data} />
    } else {
      return <></>
    }
  }

  const territoryOptions = [
    { value: '', text: 'All' },
    { value: 'NorCal,Central CA,SoCal', text: 'California (All)' },
    { value: 'NorCal', text: 'NorCal' },
    { value: 'Central CA', text: 'Central CA' },
    { value: 'SoCal', text: 'SoCal' },
    { value: 'Texas', text: 'Texas' },
    { value: 'New York', text: 'New York' },
    { value: 'Other', text: 'Other' },
  ]

  return (
    <div style={{
      flex: 1,
      display: 'flex',
    }}>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        borderRight: '1px solid #c4c4c4',
      }}>
        <AccountSelector selectedAccount={selectedAccount} setSelectedAccount={setSelectedAccount} />
        <div style={{
          color: '#565656',
          fontSize: '24px',
          fontWeight: 'bold',
          padding: '20px'
        }}>
          {'Implementation'}
        </div>
        <ImplementationSelector accountId={selectedAccount && selectedAccount.Id} selectedImplementation={selectedImplementation} setSelectedImplementation={onSetSelectedImplementation} />
        <div style={{ width: '300px', display: 'flex', flexDirection: 'column', padding: '20px 20px 0px 20px', boxSizing: 'border-box' }}>
          <div style={{
            color: '#565656',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>
            {'Territory'}
          </div>
          <SelectDropdown
            id='selectTerritory'
            options={territoryOptions}
            width={'100%'}
            onChange={(val) => setSelectedTerritory(val)}
          />
        </div>
        <div style={{ width: '300px', display: 'flex', flexDirection: 'column', padding: '20px', boxSizing: 'border-box' }}>
          <div style={{
            color: '#565656',
            fontSize: '24px',
            fontWeight: 'bold',
            marginBottom: '20px'
          }}>
            {'Date Range'}
          </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ position: 'relative'}}>
                <div style={{ margin: '0px 3px 2px 3px', color: '#565656', fontSize: '15px' }}>From</div>
                <DateInput
                  ref={dateRangeFromRef} 
                  value={dateRangeFrom || ''}
                  onChange={(val) => setDateRangeFrom(val)}
                />
                {
                  Boolean(dateRangeFrom) &&
                  <IconButtonWrapper
                    style={{ position: 'absolute', top: '22px', right: '5px' }}
                    onClick={(() => dateRangeFromRef && dateRangeFromRef.current && dateRangeFromRef.current.clearInput())}
                  >
                    <FaTimes style={{ fontSize: '18px' }}  />
                  </IconButtonWrapper>
                }
              </div>
              <div style={{ position: 'relative'}}>
                <div style={{ margin: '10px 0px 2px 3px', color: '#565656', fontSize: '15px' }}>To</div>
                <DateInput
                  ref={dateRangeToRef} 
                  value={dateRangeTo || ''}
                  onChange={(val) => setDateRangeTo(val)}
                />
                {
                  Boolean(dateRangeTo) &&
                  <IconButtonWrapper
                    style={{ position: 'absolute', top: '32px', right: '5px' }}
                    onClick={(() => dateRangeToRef && dateRangeToRef.current && dateRangeToRef.current.clearInput())}
                  >
                    <FaTimes style={{ fontSize: '18px' }}  />
                  </IconButtonWrapper>
                }
              </div>
            </div>
        </div>
      </div>
      {
        true ? //( Boolean(selectedAccountId) && Boolean(selectedImplementationId)) ?
          <div style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            padding: '20px'
          }}>
            <div style={{ position: 'relative', top: '-15px', left: '-30px' }}>
              <Tabs tabs={tabs} selectedTab={selectedTab} setSelectedTab={setSelectedTab} suppressBorderBottom={true} />
            </div>
            {
              isLoading ?
              <div style={{
                marginTop: '100px',
                flex: 1,
                display: 'flex',
                justifyContent: 'center'
              }}>
                <LoadingIcon />
              </div>
              :
              !data ?
              <div>
                {'No data found'}
              </div>
              :
              getFocusedDataStory()
            }
          </div>
        :
          <div style={{
            marginTop: '30px',
            flex: 1,
            display: 'flex',
            //justifyContent: 'center'
          }}>
            <div style={{
              color: '#565656',
              fontSize: '24px',
              fontWeight: 'bold',
              padding: '18px'
            }}>
              {'You are required to select both an Account and Implementation in order to load your Data Story.'}
            </div>
          </div>
      }
    </div>
  )
}